import {
  React,
  Component,
  withRouter,
  NavLink,
} from 'imports/CommonImports';

import {
  Drawer,
  MenuItem
} from 'material-ui';

import spacing from 'material-ui/styles/spacing';
import typography from 'material-ui/styles/typography';

import {
  GreyColor1,
  PrimaryColor1,
} from 'imports/DesignImports';

import {DoneIcon} from 'imports/IconsImports';

import logo from 'logo.png';

const styles = {
  logo: {
    cursor: 'pointer',
    fontSize: 22,
    color: typography.textFullWhite,
    lineHeight: `${spacing.desktopKeylineIncrement}px`,
    fontWeight: typography.fontWeightLight,
    backgroundColor: GreyColor1,
    paddingLeft: 40,
    height: 100,
  },
  menuItem: {
    backgroundColor: GreyColor1,
    color: GreyColor1,
    fontSize: 14
  },
  latoFont: {
    fontFamily: 'Lato'
  }
};

class LeftDrawer extends Component {
  constructor(props){
    super(props);
    this.state = {
      stageOrder: props.currentStage.stage.order,
      position: props.user.position,
    }
  }
  componentWillReceiveProps(props){
    this.setState({
      stageOrder: props.currentStage.stage.order,
      position: props.user.position,
    })
  }

  render(){
    let stageOrder = this.state.stageOrder;
    let position = this.state.position;
    return (
      <Drawer
        docked={true}
        open={this.props.navDrawerOpen}
        containerStyle={styles.menuItem}
        >
          <div style={styles.logo}>
            <a href="/home"><img src={logo} alt="Índice i3" style={{maxWidth:"170px"}} /></a>
          </div>
          {position === 'Innspiral' && (
            <NavLink activeStyle={{backgroundColor:'#D6D6D6'}} to='/consultant' style={{textDecoration: 'none', display: 'block'}}>
              <MenuItem style={styles.latoFont}>Listado de proyectos</MenuItem>
            </NavLink>
          )}
          {(position === 'Gerente Innovación' || position === 'Innspiral') &&
          <div style={styles.menuItem}>
            <MenuItem style={{...styles.latoFont, ...{color: PrimaryColor1}}} disabled={true}>1. Criterios
              <NavLink activeStyle={{backgroundColor:'#D6D6D6'}} to='/manager_criteria' style={{textDecoration: 'none', display: 'block'}}>
                <MenuItem style={styles.latoFont} rightIcon={stageOrder > 3 ? <DoneIcon/> : null}>1.1 Definición</MenuItem>
              </NavLink>
            </MenuItem>
            <MenuItem style={{...styles.latoFont, ...{color: PrimaryColor1}}} disabled={true}>2. Portafolio de proyectos
              <NavLink activeStyle={{backgroundColor:'#D6D6D6'}} to='/portfolio/setup' style={{textDecoration: 'none', display: 'block'}}>
                <MenuItem style={styles.latoFont} rightIcon={stageOrder > 5 ? <DoneIcon/> : null}>2.1 Fechas</MenuItem>
              </NavLink>
              <NavLink activeStyle={{backgroundColor:'#D6D6D6'}} to='/portfolio/postulation/projects' style={{textDecoration: 'none', display: 'block'}}>
                <MenuItem style={styles.latoFont} rightIcon={stageOrder > 6 ? <DoneIcon/> : null}>2.2 Postulación</MenuItem>
              </NavLink>
              <NavLink activeStyle={{backgroundColor:'#D6D6D6'}} to='/portfolio/selection' style={{textDecoration: 'none', display: 'block'}}>
                <MenuItem style={styles.latoFont} rightIcon={stageOrder > 7 ? <DoneIcon/> : null}>2.3 Selección por criterios</MenuItem>
              </NavLink>
              <NavLink activeStyle={{backgroundColor:'#D6D6D6'}} to='/portfolio/files' style={{textDecoration: 'none', display: 'block'}}>
                <MenuItem style={styles.latoFont} rightIcon={stageOrder > 9 ? <DoneIcon/> : null}>2.4 Fichas</MenuItem>
              </NavLink>
              <NavLink activeStyle={{backgroundColor:'#D6D6D6'}} to='/portfolio/economic_selection' style={{textDecoration: 'none', display: 'block'}}>
                <MenuItem style={styles.latoFont} rightIcon={stageOrder > 10 ? <DoneIcon/> : null}>2.5 Selección económica</MenuItem>
              </NavLink>
            </MenuItem>
            <MenuItem style={{...styles.latoFont, ...{color: PrimaryColor1}}} disabled={true}>3. Dashboard
              <NavLink activeStyle={{backgroundColor:'#D6D6D6'}} to='/dashboard/summary' style={{textDecoration: 'none', display: 'block'}}>
                <MenuItem style={styles.latoFont} rightIcon={stageOrder > 11 ? <DoneIcon/> : null}>3.1 Resumen</MenuItem>
              </NavLink>
              {/* <NavLink activeStyle={{backgroundColor:'#D6D6D6'}} to='/dashboard/by_projects' style={{textDecoration: 'none', display: 'block'}}>
                <MenuItem style={styles.latoFont} rightIcon={stageOrder > 11 ? <DoneIcon/> : null}>3.2 Datos por proyecto</MenuItem>
              </NavLink>
              <NavLink activeStyle={{backgroundColor:'#D6D6D6'}} to='/dashboard/by_area' style={{textDecoration: 'none', display: 'block'}}>
                <MenuItem style={styles.latoFont} rightIcon={stageOrder > 11 ? <DoneIcon/> : null}>3.3 Datos por área</MenuItem>
              </NavLink> */}
            </MenuItem>
          </div>
          }
          {position === 'Admin' &&
          <div style={styles.menuItem}>
            <NavLink activeStyle={{backgroundColor:'#D6D6D6'}} to='/utilities' style={{textDecoration: 'none', display: 'block'}}>
              <MenuItem style={styles.latoFont}>Utilidades</MenuItem>
            </NavLink>
          </div>
          }
          { position === 'Gerente de área' &&
            <MenuItem style={{...styles.latoFont, ...{color: PrimaryColor1}}} disabled={true}>1. Portafolio de proyectos
              <NavLink activeStyle={{backgroundColor:'#D6D6D6'}} to='/portfolio/postulation/projects' style={{textDecoration: 'none', display: 'block'}}>
                <MenuItem style={styles.latoFont} rightIcon={stageOrder > 6 ? <DoneIcon/> : null}>1.1 Postulación</MenuItem>
              </NavLink>
              <NavLink activeStyle={{backgroundColor:'#D6D6D6'}} to='/portfolio/files' style={{textDecoration: 'none', display: 'block'}}>
                <MenuItem style={styles.latoFont} rightIcon={stageOrder > 10 ? <DoneIcon/> : null}>1.2 Fichas</MenuItem>
              </NavLink>
            </MenuItem>
          }
          { position === 'Líder de proyecto' &&
              <NavLink activeStyle={{backgroundColor:'#D6D6D6'}} to='/portfolio/files' style={{textDecoration: 'none', display: 'block'}}>
                <MenuItem style={styles.latoFont}>Ficha de proyecto</MenuItem>
              </NavLink>
          }
      </Drawer>
    );
  }
}

export default withRouter(LeftDrawer);



// WEBPACK FOOTER //
// ./src/components/template/LeftDrawer.js